<script setup lang="ts">
import type { Notification } from "@/models/notification";
import { notificationsService } from "@/services/notifications-service";
import { computed } from "vue";

const notifications = computed(
  () => notificationsService.state.value.notifications,
);

function notificationClass(notification: Notification) {
  return {
    "is-success": notification.type === "success",
    "is-warning": notification.type === "warning",
    "is-danger": notification.type === "error",
  };
}

function onDelete(id: string) {
  notificationsService.close(id);
}
</script>

<template>
  <div class="notification-root">
    <div class="notifications">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="notification is-light"
        :class="notificationClass(notification)"
      >
        <button class="delete" @click="onDelete(notification.id)"></button>
        {{ notification.text }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notification-root {
  position: fixed;
  top: 0;
  right: 1rem;
  z-index: 99999;
  display: flex;

  button.delete {
    top: 6px;
    right: 6px;
  }

  .notifications {
    .notification {
      width: 20vw;
      margin-block: 1rem;
      opacity: 1;
      font-weight: 500;
      transform: translateX(0);
      transition:
        transform 0.5s var(--ease-elastic-in-out-5),
        opacity 0.5s;
      @starting-style {
        opacity: 0;
        transform: translateX(105%);
      }
    }
  }
}
</style>
